const planStatus = {
	active: "ACTIVE",
	inactive: "INACTIVE",
	expired: "EXPIRED"
};

const planName = {
	health_plan: "Health Plan",
	clinic_card: "Clinic Card",
	KSOP: "KSOP",
	GLI: "Group Life Indemnity",
	GSTD: "Group Short Term Disability",
	HOO: "Helping Our Own",
	christmas_club: "Christmas Club",
	GLTD: "Group Long Term Disability"
};

const plans = [
	planName.health_plan,
	planName.clinic_card,
	planName.GLI,
	planName.GSTD,
	planName.HOO,
	planName.christmas_club,
	planName.KSOP,
	planName.GLTD
];

const VEBPlans = [
	"Cancer",
	"Accident",
	"Whole life",
	"Short Term Disability",
	"Critical Illness",
	"Hospital Indemnity",
	"Group Life Indemnity",
	"Group Limited Indemnity",
	"Family Protection",
	"Doc and Rx",
	"Vision",
	"Dental"
];

export const PLAN_NAME = planName;
export const PLAN_STATUS = planStatus;
export const PLANS = plans;
export const VEB_PLANS = VEBPlans;
